import { CdkTextareaAutosize } from '@angular/cdk/text-field';
import { DatePipe } from '@angular/common';
import { HttpParams } from '@angular/common/http';
import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
//import { NgwWowService } from 'ngx-wow';
import { CommonService } from 'src/app/services/common.service';
import { DataService } from 'src/app/services/data.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { MagnifyFieldSearchComponent } from 'src/app/shared/components/magnify-field-search/magnify-field-search.component';
import {MemoryStorageService} from 'src/app/services/memory-storage.service';


@Component({
  selector: 'app-create-doa-rule',
  templateUrl: './create-doa-rule.component.html',
  styleUrls: ['./create-doa-rule.component.css']
})
export class CreateDoaRuleComponent implements OnInit {
  isBright: boolean = true;
  isOpenDoctypeModel: boolean = true;

  selectedDocumentType: any = { docTypeId: 0, docTypeName: '', isCommentMandatory: false };
  frmRulesave = new FormGroup({
    fieldselected: new FormControl('', [Validators.required]),
    txtdata: new FormControl('')
  });
  Rule_desc: any
  doc_id: any;
  matrix_id: any;
  lstData: any;
  DOA_RULE: any;
  columns: any;
  fieldList: { Id: number, Name: string }[] = [];
  column_data: any;

  @ViewChild('mySelect') mySelect: MatSelect;
  data: any;

  constructor(
    //private wowService: NgwWowService,
    private dataService: DataService,
    public commonService: CommonService,
    private dialog: MatDialog,
    private router: Router,
    private modalService: NgbModal,
    private memorystore: MemoryStorageService
  ) { }
  ngOnInit(): void {


    // this.doc_id = this.commonService.getUserInfoFromLocalStorage('current_doc_id_doa');
    // this.matrix_id = this.commonService.getUserInfoFromLocalStorage('current_matrix_id_doa');
    this.doc_id = this.memorystore.getItem('current_doc_id_doa');
    this.matrix_id = this.memorystore.getItem('current_matrix_id_doa');
    this.getRule_details();
    this.getfield_names();
  }
  getRule_details() {

    let param = {
      project_id: this.commonService.selectedProject,
      // user_id: this.commonService.getUserInfoFromLocalStorage('userId'),
      user_id: this.memorystore.getItem('userId'),
      doc_id: this.doc_id,
      matrix_id: this.matrix_id
    }

    this.dataService.getData('get_DOARuledata', param).subscribe((res) => {
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data.Table.length > 0) {
          this.DOA_RULE = res.data.Table[0].DOA_RULE;
          this.columns = res.data.Table[0].Field_mapping_detail_ids;
          this.Rule_desc = this.DOA_RULE;
        }
        else {
          this.Rule_desc = this.DOA_RULE = "";
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }
    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }


  getfield_names() {
    this.fieldList = [];
    let params = new HttpParams();
    params = params.append('project_id', this.commonService.selectedProject);
    params = params.append('subgroup_id', this.commonService.selectedSubgroup);
    params = params.append('doc_type_id', this.doc_id);

    this.dataService.getData('getfield_names_DOA', params).subscribe((res) => {
      // this.data = res.data.Table
      if (res != null && (res.error_message == null || res.error_message == "")) {
        if (res.data.Table != null) {
          for (var i = 0; i < res.data.Table.length; i++) {
            this.fieldList.push({
              Id: res.data.Table[i].id,
              Name: res.data.Table[i].name,
            });
          }

          res.data.Table.forEach(element => {
            this.data.push({
              value: element.id,
              text: element.name,
              selected: true,
            });
          });
        }
      }
      else {
        if (res.errorCode != 0 && res.errorCode == 4000) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
        if (res.errorCode != 0 && res.errorCode == 3000) {
          this.commonService.showMessageBox("Internal error")
        }
      }

      if (this.columns != null) {
        let array = this.columns.split(',');
        this.column_data = this.columns
        this.mySelect.trigger;
        this.fieldList.forEach(element => {
          var val = String(element.Id)


        });
      }

    },
      error => {
        if (error.includes("401")) {
          this.router.navigateByUrl('/unauthorized');
          return;
        }
      });
  }

  submitInvoice() {
  }

}
